/**
 * =============================================================================
 * Project: lajt-online.pl
 * Created Date: 2018-03-06, 14:52:56
 * Author: Sebastian Drzewicki <sebastian.drzewicki@gmail.com>
 * =============================================================================
 * Last Modified: 2018-03-06, 15:22:54
 * Modified By: Sebastian Drzewicki
 * =============================================================================
 * Copyright (c) 2018 Telestrada
 * =============================================================================
 */

import sRouter from '@/services/sRouter';

// COMPONENT ///////////////////////////////////////////////////////////////////
export default {
  name: 'MyIndividualAccountNumber',

  props: {
    lastInvoice: {
      type: Object,
      default() {
        return {
          amount: 0,
          posting_date: null,
          description: null,
        };
      },
    },
    subscriber: {
      type: Object,
      default() {
        return {};
      },
    },
    acl: Object,
  },

  methods: {
    changeUrl(pathObject) {
      sRouter.changeUrl(pathObject, this.$router);
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/MyAccount/MyIndividualAccountNumber/component.js